<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">
		    	Ledger Opening Balance
		    </v-toolbar-title>

		    <!-- <v-spacer></v-spacer> -->

		    <!-- <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>


		<v-form class="form-element hasToolbar hasBigFooter grey-back" id="form">

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<!-- <v-alert :value="true" type="info" icon="info" transition="slide-y-transition">
				<span>This opening date will set as default for all opening ledgers or opening stock you will add later.</span>
			</v-alert> -->
			<v-subheader class="mb-2" white-background>Opening Date
				<v-spacer></v-spacer>
				<!-- <span medium-theme-color @click="fn_changeOpeningDate"><u>{{$root.CurrentBusiness.OpeningDate | moment("DD-MMM-YYYY")}}</u></span> -->
				<span medium-theme-color>{{$root.CurrentBusiness.OpeningDate | moment("DD-MMM-YYYY")}}</span>
			</v-subheader>

			<v-layout wrap padding-top-ten white-background>

				<v-flex xs12 sm12 md12 form-item @click="fn_openAccountLedgers('ref_accountLedger')">
	               <v-text-field  
		               	readonly
		               	v-model="Form.accountLedgerName" 
		               	:hide-details="Form.accountLedgerName"
		               	label="Ledger"
		               	:onUpdate="fn_updateAccountLedger" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	ref="ref_accountLedger"
		               	v-validate="'required'" 
	               		data-vv-name="account ledger" 
	               		:error-messages="errors.collect('account ledger')"
	               		required>
	               </v-text-field>

	               <div custom-message v-if="Form.accountLedgerName && Form.ledgerData">
	               		<!-- <span light-opacity-color>Balance:</span> -->
						<span light-opacity-color>{{ fn_balanceLabel(Form.ledgerData) }}</span>
	               		<span :class="[Form.ledgerData.balance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(Form.ledgerData.balance)}}</span>
	               </div>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
	               	<v-text-field 
	               		type="number" 
	               		prefix="₹"
	               		v-model.number="Form.amount" 
	               		label="Amount" 
	               		placeholder=" "
	               		v-validate="'required|decimal:2'" 
	               		data-vv-name="amount" 
	               		:error-messages="errors.collect('amount')"
	               		required>
	               			
	               	</v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item v-if="Form.accountLedgerName && Form.ledgerData && Form.ledgerData.groupTypeId">
	               	<!-- <v-radio-group v-model="Form.amountType" row @change="fn_changeAmountType">
				      <v-radio label="Credit" :value="0" :disabled="disableCredit"></v-radio>
				      <v-radio label="Debit" :value="1" :disabled="disableDebit"></v-radio>
				    </v-radio-group> -->
				    <v-radio-group v-model="Form.amountType" row>
				    	<v-radio :label="$root.fn_payOrReceive(1, Form.ledgerData.groupTypeId)" :value="1"></v-radio>
				      	<v-radio :label="$root.fn_payOrReceive(0, Form.ledgerData.groupTypeId)" :value="0"></v-radio>
				    </v-radio-group>
	            </v-flex>
	            
			</v-layout>

			<!-- <v-list two-line nopadding margin-top-ten v-if="Form.showBwb">
			  	<v-subheader>Bill Wise Breakup<v-spacer></v-spacer>
			  		<v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_addBwb">
			  			Add
			  		</v-btn>
			  	</v-subheader>

			  	<v-divider></v-divider>

			  	<v-list nopadding v-if="Form.amount && onAccount">
				  	<v-list-tile>
				  		<v-list-tile-content>
				  			<v-list-tile-title>On Account</v-list-tile-title>
				  		</v-list-tile-content>
				  		<v-list-tile-action>&#8377; {{onAccount}}</v-list-tile-action>
				  	</v-list-tile>
				  	<v-divider></v-divider>
				</v-list>

			  	<div v-for="(item, index) in Form.bwbItems" :key="index">
			  		<v-list-tile>
				  		<v-list-tile-content>
				  			<v-list-tile-title>{{item.transactionListId == 50001 ? 'Sale' : 'Purchase'}} | {{item.refNumber}}</v-list-tile-title>
				  			<v-list-tile-sub-title>{{item.refDate | moment("DD MMM YYYY")}}</v-list-tile-sub-title>
				  		</v-list-tile-content>
				  		<v-list-tile-action>
				  		  	<v-menu>
							    <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
							    <v-list nopadding>
							        <v-list-tile @click="fn_editBwbItem(item)">
							          <v-list-tile-title>Edit</v-list-tile-title>
							        </v-list-tile>

						        	<v-divider></v-divider>

							        <v-list-tile @click="fn_removeBwbItem(item.transactionId, index)">
							          <v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
						      	</v-list>
						    </v-menu>

						    &#8377; {{$root.numberToLocale(item.amount)}}
				  		</v-list-tile-action>
				  	</v-list-tile>

				  	<v-divider v-if="Form.bwbItems.length-1 != index"></v-divider>
			  	</div>
			  	
			</v-list> -->

			<v-layout wrap margin-top-ten white-background>
				<v-list full-width nopadding>
				  	<v-list-tile>

				  		<v-list-tile-action v-if="Form.transactionData.notes">
			            	<v-btn icon @click="Form.transactionData.notes = ''">
					  			<v-icon>close</v-icon>
					  		</v-btn>
			            </v-list-tile-action>

			          	<v-list-tile-content full-width @click="fn_addNote">
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
						  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
			            </v-list-tile-content>
						
				    </v-list-tile>
				</v-list>

				<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
					<v-divider></v-divider>
				  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</v-layout>

			<!-- <v-layout wrap margin-top-ten white-background>
				<v-list full-width nopadding>
				  	<v-list-tile border-bottom-thin>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
            					{{Form.transactionData.notes ? 'Edit' : 'Add'}}
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>	

				<v-card flat class="note-card" v-if="Form.transactionData.notes">
				  <v-card-text v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</v-layout> -->

			<!-- <div id="note" v-if="Form.transactionData.notes" class="margin-top-ten">
				<v-list full-width nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
            					Edit
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-divider></v-divider>

				<v-card flat class="note-card">
				  <v-card-text v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</div> -->
		
		</v-form>

		<div white-background full-width nopadding style="position:fixed;bottom:0;">
			<v-layout row wrap>
				<v-flex xs12 sm12 md12 height48>
					<v-btn color="primary" full-height nomargin block no-round-borders noshadow @click="fn_checkValidations">Save</v-btn>
				</v-flex>
			</v-layout>
		</div>

	    <v-dialog v-model="loading" no-click-animation no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <dialog-note ref="ref_dialogNote"></dialog-note>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-bwb ref="ref_dialogBwb" :openDatePicker="fn_openDatePicker" :saveBwbItem="fn_saveBwbItem"></dialog-bwb> -->

	    <!-- <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :maxDate="bwbMaxDate" :updateDate="fn_updateDate"></dialog-datepicker> -->

	    <!-- <dialog-datepicker-opening ref="ref_dialogDatePickerOpening" :selected="openingDate" :updateDate="fn_updateDateOpening" :minDate="minDate" :maxDate="maxOpeningDate"></dialog-datepicker-opening> -->

	    
	    <!-- <dialog-confirmation ref="ref_dialogConfirmation" header="Set Opening Date?" :actionMethod="fn_changeOpeningDate"></dialog-confirmation> -->


		<dialog-parties ref="ref_dialogLedger" :newParty="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-parties>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>

	    <!-- <dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_gotoSetupDrive"></dialog-drive-alert> -->

	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;
const ledgerGroupTypeId = require('../../../../config.js').configs.ledgerGroupTypeId;
// const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;

const transactionData = require('../../datamodel').data.transactionData;

import dialogNote from '../dialogs/dialog_note'
import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'
import dialogParties from '../../../dialogs/dialog_parties'

import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'

// import dialogBwb from './dialogs/dialog_bwb_form'
// import dialogDatePicker from './dialogs/dialog_datepicker'
// import dialogDatePickerOpening from '../dialogs/dialog_datepicker_opening'

// import dialogConfirmation from '../../../dialogs/dialog_confirmation'



const transactionTypes = require('../../../../config.js').configs.transactionTypes;

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		data(){
			return{

				Form:{
					"transactionData": JSON.parse(JSON.stringify(transactionData)),
					"accountLedgerId":null,
					"accountLedgerName":null,
					"amount":null, 
					"amountType":null,

					"billData":JSON.parse(JSON.stringify(transactionData)),
					// "bwbItems":[],
					// "showBwb": false,
					"ledgerData":null,
					"isNew":true
				},


				loading:false,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,
				// loadedFromDraft:false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				invalidForm:false,
				newLedgerGroupTypeId:null
				// selectedDate:new Date,

				// saleTransactionListId: transactionTypes.bwbRefSaleInvoice.id,
				// purchaseTransactionListId: transactionTypes.bwbRefPurchaseInvoice.id,

				// maxOpeningDate:null,
				// openingDate:null,
				// minDate:null,
				// bwbMaxDate:null
			}
		},
		components:{
			'dialog-note':dialogNote,
			'dialog-discard': dialogDiscard,
			'dialog-parties':dialogParties,
			'dialog-drive-alert':dialogDriveAlert
			// 'dialog-bwb': dialogBwb,
			// 'dialog-datepicker':dialogDatePicker,
			// 'dialog-datepicker-opening':dialogDatePickerOpening,
			// 'dialog-confirmation':dialogConfirmation
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.accountLedgerName);
                    }
                    this.unwatch = false;
                },
                deep: true
            }
		},
		methods:{

			fn_showMsg: function(){
				if(this.disableDebit || this.disableCredit){
					this.showToast("You need to remove billwise breakup items in order to change");
				}
			},

			// fn_changeAmountType: function(value){
			// 	// if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.customer && value == 1){
			// 	// 	this.Form.showBwb = true;
			// 	// }
			// 	// else if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.supplier && value == 0){
			// 	// 	this.Form.showBwb = true;
			// 	// }
			// 	// else{
			// 	// 	this.Form.showBwb = false;
			// 	// }
			// 	if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.customer || this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.supplier){
			// 		this.Form.showBwb = true;
			// 	}
			// 	else{
			// 		this.Form.showBwb = false;
			// 	}
			// },

			// fn_showHideBwb: function(){
			// 	let self = this;
				
			// 	if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.customer){
			// 		this.Form.showBwb = true;
			// 		setTimeout(function(){
			// 			self.Form.amountType = 1;
			// 		},100)
			// 	}
			// 	else if(this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.supplier){
			// 		this.Form.showBwb = true;
			// 		setTimeout(function(){
			// 			self.Form.amountType = 0;
			// 		},100)
			// 	}
			// 	else{
			// 		this.Form.showBwb = false;
			// 	}
			// },

			

			// fn_openConfirmationDialog: function () {
			// 	this.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogConfirmation');
			// },

			// fn_openDatePicker: function (date) {
			// 	let self = this;
			// 	this.selectedDate = date;
			// 	setTimeout(function () {
			// 		self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
			// 	})
			// },

			// fn_updateDate: function (value) {
			// 	this.Form.billData.refDate = value;
			// 	this.fn_closeDialog();
			// },

			// fn_addBwb: function(){
			// 	this.Form.billData = JSON.parse(JSON.stringify(transactionData));
			// 	this.Form.billData.refDate = new Date();
			// 	this.Form.billData.transactionListId = this.Form.amountType ? this.saleTransactionListId : this.purchaseTransactionListId;
			// 	this.fn_openBwbDialog();
			// },

			// fn_openBwbDialog: function(){
			// 	this.fn_openDialogWeb('web', 'Bwb', 'ref_dialogBwb');
			// },

			// fn_saveBwbItem: function(bwbItem){
			// 	let billWiseBreakupItem = JSON.parse(JSON.stringify(bwbItem));
			// 	if(!billWiseBreakupItem.transactionId){
			// 		billWiseBreakupItem.transactionId = this.guid();
			// 		this.Form.bwbItems.push(billWiseBreakupItem);
			// 	}
			// 	else{
			// 		let itemIndex = this.Form.bwbItems.findIndex(item=>{
			// 			return item.transactionId == billWiseBreakupItem.transactionId;
			// 		})
			// 		this.Form.bwbItems.splice(itemIndex, 1, billWiseBreakupItem);
			// 	}
			// 	this.fn_closeDialog();

			// 	let self = this;
			// 	setTimeout(function(){
			// 		self.$refs['ref_dialogBwb'].disableBtn = false;	
			// 	},1000);
			// },

			// fn_editBwbItem: function(item){
			// 	this.Form.billData = JSON.parse(JSON.stringify(item));
			// 	this.fn_openBwbDialog();
			// },

			// fn_removeBwbItem: function(transactionId, index){
			// 	transactionId ? this.fn_checkReference(transactionId, index) : this.Form.bwbItems.splice(index, 1);
			// },

			// fn_checkReference: function(transactionId, index){
			// 	let self = this;
			// 	this.getData('CheckReferenceTransaction', transactionId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				if(JSON.parse(response)){
			// 					self.showToast("Unable to delete as already used in transactions");
			// 				}
			// 				else{
			// 					self.Form.bwbItems.splice(index, 1);
			// 				}
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard');
			},

			fn_comingSoon: function () {
				this.showToast("Coming Soon...");
			},

			// fn_openAccountLedgers: function (ref) {

			// 	let viewDialogObject = { ToolbarTitle:"Ledger", groupTypeId:null, action:null, accountGroups:null, accountGstTypes:null };
			// 	viewDialogObject.ref = ref;
			// 	viewDialogObject.action = "new";
			// 	viewDialogObject.enableFilterChip = true;

			// 	viewDialogObject.groupTypeId = this.Form.ledgerData && this.Form.ledgerData.groupTypeId ? this.Form.ledgerData.groupTypeId : 101;

			// 	this.newLedgerGroupTypeId = viewDialogObject.groupTypeId;

			// 	var paramObject = {};
			// 	paramObject.defaultValue = {"id":null, "name":null};

			// 	if(this.Form.accountLedgerId && this.Form.accountLedgerName){
			// 		viewDialogObject.selectedItem = {itemId:this.Form.accountLedgerId, itemName:this.Form.accountLedgerName};
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.$nextTick(() => {
			// 		this.fn_openDialogWeb('web', 'Ledger', 'ref_dialogLedger');
			// 	})
			// },

			fn_openAccountLedgers: function () {
				this.fn_openAccountLedgerDialog('android', 'AccountLedger', 'ref_accountLedger')
			},

			fn_openAccountLedgerDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.enableFilterChip = true;

				let defaultGroupTypeId = 101;

				// viewDialogObject.groupTypeId = this.Form.partyId ? this.Form.partyDetails.groupTypeId : defaultGroupTypeId;
				viewDialogObject.groupTypeId = this.Form.ledgerData && this.Form.ledgerData.groupTypeId ? this.Form.ledgerData.groupTypeId : defaultGroupTypeId;

				this.newLedgerGroupTypeId = viewDialogObject.groupTypeId;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.accountLedgerId && this.Form.accountLedgerName){
					paramObject.defaultValue = {"id":this.Form.accountLedgerId, "name":this.Form.accountLedgerName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
				let self = this;
				if(!isRemoved){
					if(selectedValueId && this.Form.accountLedgerId != selectedValueId){
					//	//getting ledger data from groupTypeId as we are showing bwb only customers and suppliers

						this.fn_get('TransactionByPartyId', selectedValueId, function () {
							self.Form.accountLedgerId = selectedValueId;
			        		self.Form.accountLedgerName = selectedValueName;

			        		self.fn_getLedgerData(selectedValueId);
						});
					}
				}
				else{
					this.Form.accountLedgerId = null;
		        	this.Form.accountLedgerName = null;
		        	this.fn_clearForm();
				}

			},

		//	// getting ledger data from groupTypeId as we are showing bwb only customers and suppliers
			// fn_getLedgerData: function(selectedValueId, callShowHideBwb){
			fn_getLedgerData: function(selectedValueId){
				let self = this;
				this.getData('Ledger', selectedValueId, 
					{
						onSuccess: function(response){
							console.log(response);

							self.Form.ledgerData = JSON.parse(response);

							if(!self.Form.transactionData.transactionId && self.Form.ledgerData && self.Form.ledgerData.groupTypeId){
								if(self.Form.ledgerData.groupTypeId == 101 || self.Form.ledgerData.groupTypeId == 103){
									self.Form.amountType = 1;
								}
								else{
									self.Form.amountType = 0;
								}
							}
							// !self.Form.transactionData.transactionId ? self.fn_showHideBwb() : self.fn_changeAmountType(self.Form.amountType);

				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	let bottomMenu = null;

			// 	let menuItem_Note = null;
			// 	!this.Form.transactionData.notes ? menuItem_Note = menuItem.addNote : menuItem_Note = menuItem.editNote;

			// 	bottomMenu = {"BottomMenu": [menuItem.save, menuItem_Note,  menuItem.reset]};

			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				this.showLoading('Please wait...');
				this.$validator.validateAll().then((result) => {
			        if (result) {
			        	// if(this.bwbTotal > this.Form.amount){
			        	// 	this.showToast('On account cannot be negative');
			        	// 	this.hideLoading();
			        	// 	return;
			        	// }

			        	if(this.Form.amount <= 0){
			        		this.showToast('Amount should be greater than zero');
			        		this.hideLoading();
			        		return;
			        	}

			           	this.fn_post();
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        	this.hideLoading();
			        }
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('Transaction', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	// self.fn_setMinTransactionDate();
				          	self.fn_cleanUp();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
							let response = JSON.parse(error);
							if(response && response.openingLedgerExistsError){
                                self.showToast("Opening already added.");
                            }
				        }
					}
		        );
			},

			fn_cleanUp: function () {
	          	let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.hideLoading();
					self.$router.go(-1);
				});
			},

			fn_post: function(){

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.partyId = this.Form.accountLedgerId;

				let amount = this.Form.amount ? this.Form.amount : 0;
				this.Form.transactionData.amount = amount  //debit or credit amount
				this.Form.transactionData.roundedAmount = Math.round(amount); //or creditTotal amount
				this.Form.transactionData.status = 1;
				this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
				this.Form.transactionData.refDate = null;

				//subtracted 1 day from opening date as we are adding opening one day less than user selected opening date
				// let od = new Date(JSON.parse(JSON.stringify(this.openingDate)));
				let od = new Date(JSON.parse(JSON.stringify(this.$root.CurrentBusiness.OpeningDate)));
	            od.setDate(od.getDate()-1);
				// this.Form.transactionData.transactionDate = new Date(od);
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(od);

				// let grossAmount = this.roundUpto2Decimals(amount - this.bwbTotal);
				let grossAmount = this.roundUpto2Decimals(amount);

				if((this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.customer && this.Form.amountType == 0) || (this.Form.ledgerData.groupTypeId == ledgerGroupTypeId.supplier && this.Form.amountType == 1)){
					this.Form.transactionData.grossAmount = -grossAmount;
				}
				else{
					this.Form.transactionData.grossAmount = grossAmount;
				}

				// this.Form.transactionData.onAccount = this.onAccount;
				this.Form.transactionData.onAccount = null;

				let postObj = {};
				postObj = JSON.parse(JSON.stringify(this.Form.transactionData));

				let ledgerAccountAmount = amount;

				//Preparing Object for transaction ledger table
				let transactionLedgerObj = {};

				transactionLedgerObj.transactionLedgerId = this.guid();
				transactionLedgerObj.accountLedgerId = this.Form.accountLedgerId;
				transactionLedgerObj.orderNumber = 1;
				transactionLedgerObj.amount = amount;
				transactionLedgerObj.amountType = this.Form.amountType;

				postObj.transactionLedgers = [];
				postObj.transactionLedgers.push(transactionLedgerObj);
				
				//Preparing Object for ledger accounts table
				let ledgerAccountObj = {};

				ledgerAccountObj.ledgerAccountId = this.guid();
				ledgerAccountObj.accountId =  this.Form.accountLedgerId;
				ledgerAccountObj.amount =  this.Form.amountType == 1 ? ledgerAccountAmount : -ledgerAccountAmount;
				// ledgerAccountObj.amount = ledgerAccountAmount;
				ledgerAccountObj.amountType =  this.Form.amountType;

				postObj.ledgerAccounts = [];
				postObj.ledgerAccounts.push(ledgerAccountObj);

				//bwbItems
				// postObj.bwbItems = [];
				// for(let i=0; i<this.Form.bwbItems.length; i++){
				// 	!this.Form.bwbItems[i].createdDate ? this.Form.bwbItems[i].createdDate =  new Date() : '';
				// 	this.Form.bwbItems[i].modifiedDate =  new Date();
				// 	this.Form.bwbItems[i].partyId = this.Form.accountLedgerId;
				// 	this.Form.bwbItems[i].roundedAmount = Math.round(this.Form.bwbItems[i].amount);
				// 	this.Form.bwbItems[i].netAmount = this.Form.bwbItems[i].amount;
				// 	this.Form.bwbItems[i].parentTransactionId = this.Form.transactionData.transactionId;
				// 	this.Form.bwbItems[i].transactionDate = this.Form.bwbItems[i].refDate;
				// 	postObj.bwbItems.push(this.Form.bwbItems[i]);
				// }

				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

				console.log(JSON.stringify(postObj));
				this.fn_saveLocal(postObj);
			},

			fn_get: function (type, itemId, callback) {
				this.Form.isNew = false;
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData(type, itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							if(response){
								let data = JSON.parse(response);
								self.fn_bindData(data);
							}
							else{
								self.fn_clearForm();
								callback();
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},


			fn_bindData: function (data) {
				this.Form.transactionData.additionalData = data.additionalData;
				this.Form.transactionData.amount = data.amount;
				this.Form.transactionData.businessId = data.businessId;
				this.Form.transactionData.createdBy = data.createdBy;
				this.Form.transactionData.createdDate = data.createdDate;
				this.Form.transactionData.currencyId = data.currencyId;
				this.Form.transactionData.dueDate = data.dueDate;
				this.Form.transactionData.dueType = data.dueType;
				this.Form.transactionData.modifiedBy = data.modifiedBy;
				this.Form.transactionData.modifiedDate = data.modifiedDate;
				this.Form.transactionData.notes = data.notes;
				this.Form.transactionData.partyId = data.partyId;
				this.Form.transactionData.paymentMode = data.paymentMode;
				this.Form.transactionData.prefix = data.prefix;
				this.Form.transactionData.refDate = data.refDate;
				this.Form.transactionData.refNumber = data.refNumber;
				this.Form.transactionData.roundedAmount = data.roundedAmount;
				this.Form.transactionData.salesmanId = data.salesmanId;
				this.Form.transactionData.status = data.status;
				this.Form.transactionData.suffix = data.suffix;
				this.Form.transactionData.transactionDate = data.transactionDate;
				this.Form.transactionData.transactionId = data.transactionId;
				this.Form.transactionData.transactionListId = data.transactionListId;
				this.Form.transactionData.transactionNumber = data.transactionNumber;

				let transactionLedger = JSON.parse(JSON.stringify(data.transactionLedgers[0]));
				this.Form.accountLedgerName = transactionLedger.accountLedgerName;
				this.Form.accountLedgerId = transactionLedger.accountLedgerId;
				this.Form.amount = transactionLedger.amount;
				this.Form.amountType = transactionLedger.amountType;


				// this.Form.bwbItems = [];
				// if(data.bwbItems && data.bwbItems.length){
				// 	for(let i=0; i<data.bwbItems.length; i++){
				// 		let bwbData = JSON.parse(JSON.stringify(transactionData));
				// 		bwbData.transactionId = data.bwbItems[i].transactionId;
				// 		bwbData.refDate = data.bwbItems[i].refDate;
				// 		bwbData.transactionDate = data.bwbItems[i].transactionDate;
				// 		bwbData.refNumber = data.bwbItems[i].refNumber;
				// 		bwbData.amount = data.bwbItems[i].amount;
				// 		bwbData.transactionListId = data.bwbItems[i].transactionListId;
				// 		bwbData.createdDate = data.bwbItems[i].createdDate;
				// 		this.Form.bwbItems.push(bwbData);
				// 	}
				// }

				//getting ledger data from groupTypeId as we are showing bwb only customers and suppliers
				this.fn_getLedgerData(data.partyId);

				let self = this;
				setTimeout(function(){
					self.$root.fn_copyFormObject(self.Form, self.formId);
				},300);
			},


			fn_clearForm: function(){
				this.Form = {
					"transactionData": JSON.parse(JSON.stringify(transactionData)),
					"accountLedgerId":null,
					"accountLedgerName":null,
					"amount":null, 
					"amountType":0,
					"billData":JSON.parse(JSON.stringify(transactionData)),
					// "bwbItems":[],
					// "showBwb":false,
					"ledgerData":null
				}
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					let groupTypeId = this.newLedgerGroupTypeId ? this.newLedgerGroupTypeId : 101;
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId: groupTypeId, ls:1}});
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
				else if(menuAction=='addnote'){
					this.fn_addNote();
				}
			},

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#note', self.scrollOptions);
				},300);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.transactionData.transactionId){
					this.fn_get('Transaction', this.Form.transactionData.transactionId);
				}
				else{
					this.fn_clearForm();
					// this.fn_checkOpening(transactionTypes.openingStock.id, transactionTypes.openingLedger.id);
				}

				this.fn_removeDraft(this.draftStorageId);
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				let itemData = null;
				if(localStorage.getItem('newItem')){

					itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
					    case "ledger":
					    	this.fn_updateAccountLedger(itemData.id, itemData.name, false)
					        break;
					        
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				if(this.$route.query && this.$route.query.dt && !itemData){
					this.fn_updateAccountLedger(this.$route.query.id, this.$route.query.name, false);
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_selectedGroupTypeId: function(groupTypeId){
				this.newLedgerGroupTypeId = Number(groupTypeId);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			console.log(this.$route);

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				// !this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") ?  this.fn_checkTransactionCount() : '';
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ?  this.fn_checkTransactionCount() : '';
			if(!this.$root.CurrentBusiness.DataDrive){
				this.fn_checkTransactionCount(()=>{
					if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
						this.fn_openDialogDriveSetup();
					}
				})
			}

			// this.bwbMaxDate = (this.fn_getFiscalYear()+1)+"-03-31";

			var formsArray = [];
			if(localStorage.getItem('openingledgerform')){
				formsArray = JSON.parse(localStorage.getItem('openingledgerform'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('openingledgerform', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_selectedGroupTypeId = this.fn_selectedGroupTypeId;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('temp', 'Opening Ledger');

			// this.fn_checkOpening(transactionTypes.openingStock.id, transactionTypes.openingLedger.id);
		},
		// computed:{
		// 	// transactionListId
		// 	// sale bill 50001
		// 	// purchase bill 50002
		// 	// bwbTotal: function(){
		// 	// 	let total = 0;
		// 	// 	for(let i=0; i<this.Form.bwbItems.length; i++){
		// 	// 		if(this.Form.bwbItems[i].transactionListId == 50001){
		// 	// 			if(this.Form.amountType){
		// 	// 				total -= this.Form.bwbItems[i].amount; //subtract sale bill
		// 	// 			}
		// 	// 			else{
		// 	// 				total += this.Form.bwbItems[i].amount; //add sale bill
		// 	// 			}
		// 	// 			// total -= this.Form.bwbItems[i].amount; //subtract sale bill
		// 	// 		}
		// 	// 		else{
		// 	// 			if(this.Form.amountType){
		// 	// 				total += this.Form.bwbItems[i].amount; //add purchase bill
		// 	// 			}
		// 	// 			else{
		// 	// 				total -= this.Form.bwbItems[i].amount; //subtract purchase bill
		// 	// 			}
		// 	// 			// total += this.Form.bwbItems[i].amount; //add purchase bill
		// 	// 		}
		// 	// 	}
		// 	// 	return total;
		// 	// },
		// 	// onAccount: function(){
		// 	// 	if(this.bwbTotal){
		// 	// 		// return this.roundUpto2Decimals(this.Form.amount - this.bwbTotal);
		// 	// 		return this.roundUpto2Decimals(this.Form.amount + this.bwbTotal);
		// 	// 	}
		// 	// 	else{
		// 	// 		return null;
		// 	// 	}
		// 	// },
		// 	// disableDebit: function(){
		// 	// 	if(this.Form.accountLedgerId && !this.Form.amountType && this.Form.bwbItems.length){
		// 	// 		return true;
		// 	// 	}
		// 	// 	else{
		// 	// 		return false;
		// 	// 	}
		// 	// },
		// 	// disableCredit: function(){
		// 	// 	if(this.Form.accountLedgerId && this.Form.amountType && this.Form.bwbItems.length){
		// 	// 		return true;
		// 	// 	}
		// 	// 	else{
		// 	// 		return false;
		// 	// 	}
		// 	// }
		// },
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='openingLedgerItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//checking if draft exist
		  		vm.fn_isDraft(function(isDraft){
		  			if(itemId && !isDraft){
		  				vm.fn_get('Transaction', itemId);
		  			}

		  			if(!isDraft && !itemId && !localStorage.getItem('newItem') && (to.query && !to.query.dt)){
		  				if(!vm.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive")){
		                    vm.fn_checkTransactionCount(function(transactionCount){
		                        if(transactionCount < 10){
		                            setTimeout(function(){
		                                vm.fn_openAccountLedgers()
		                            },300);
		                        } 
		                    })  
		                }
		                else{
		                	setTimeout(function(){
	                            vm.fn_openAccountLedgers()
	                        },300);
		                }
		  			}
		  		})

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('openingledgerform'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true, 1);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						this.backButtonPress = false;
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					localStorage.removeItem('openingledgerform');
					localStorage.removeItem("SetDataDrive");
					next();	
				}
			}
	    },
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/opening_ledger/form.vue